import React, { useState } from 'react';

const API = '/api';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const resp = await fetch(`${API}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await resp.json();
      if (data.ok) {
        localStorage.setItem('celsia_user', JSON.stringify(data.user));
        onLogin(data.user);
      } else {
        setError(data.error || 'Credenciales incorrectas');
      }
    } catch(e) {
      setError('Error de conexión con el servidor');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0f0c 0%, #0f1a13 50%, #054526 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem'
    }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>

        {/* Logo / Brand */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          {/* Ícono circular */}
          <div style={{
            width: '80px', height: '80px', borderRadius: '50%',
            background: 'linear-gradient(135deg, #054526, #569C06)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 1rem', fontSize: '36px',
            boxShadow: '0 0 30px rgba(86,156,6,0.3)'
          }}>⚡</div>
          <div style={{ fontSize: '28px', fontWeight: '900', color: '#ffffff', letterSpacing: '2px', textTransform: 'uppercase' }}>
            <span style={{ color: '#569C06' }}>GREEN</span>{' '}
            <span style={{ color: '#ffffff' }}>ENERGY</span>
          </div>
          <div style={{ fontSize: '11px', color: '#5a8a6a', marginTop: '6px', letterSpacing: '2px', textTransform: 'uppercase' }}>
            MOVILIDAD ELÉCTRICA • ENERGÍA SOSTENIBLE
          </div>
        </div>

        {/* Card de login */}
        <div style={{
          background: 'rgba(15, 26, 19, 0.9)',
          border: '1px solid #1a3326',
          borderRadius: '14px', padding: '2rem',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
        }}>
          <div style={{ fontSize: '15px', fontWeight: '700', color: '#e0ede5', marginBottom: '1.5rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Iniciar sesión
          </div>

          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ fontSize: '11px', color: '#5a8a6a', display: 'block', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Correo electrónico
              </label>
              <input
                type="email" value={email} onChange={e=>setEmail(e.target.value)}
                placeholder="Correo electrónico" required
                style={{ width: '100%', padding: '10px 14px', background: '#0a0f0c', border: '1px solid #1a3326', borderRadius: '8px', color: '#e0ede5', fontSize: '14px' }}
              />
            </div>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ fontSize: '11px', color: '#5a8a6a', display: 'block', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Contraseña
              </label>
              <input
                type="password" value={password} onChange={e=>setPassword(e.target.value)}
                placeholder="••••••••" required
                style={{ width: '100%', padding: '10px 14px', background: '#0a0f0c', border: '1px solid #1a3326', borderRadius: '8px', color: '#e0ede5', fontSize: '14px' }}
              />
            </div>

            {error && (
              <div style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid #f87171', borderRadius: '8px', padding: '10px 14px', marginBottom: '1rem', fontSize: '13px', color: '#f87171' }}>
                ❌ {error}
              </div>
            )}

            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '13px',
              background: loading ? '#1a3326' : 'linear-gradient(135deg, #054526, #569C06)',
              border: 'none', borderRadius: '8px', color: '#fff',
              cursor: loading ? 'default' : 'pointer',
              fontSize: '14px', fontWeight: '800',
              letterSpacing: '1px', textTransform: 'uppercase',
              boxShadow: loading ? 'none' : '0 4px 20px rgba(86,156,6,0.3)',
              transition: 'all 0.2s'
            }}>
              {loading ? '⏳ Iniciando sesión...' : '→ Ingresar'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '11px', color: '#3a6a4a', letterSpacing: '1px' }}>
          GREEN ENERGY v1.0.0 — EV Charge Management
        </div>
      </div>
    </div>
  );
}
